/* eslint-disable operator-linebreak */
/* eslint-disable no-undef */
WB.Routing = WB.Routing || {};

var bypassParameter = 'bp';

/*
 * The Router
 *
 * This router hooks into our middleware to run whatever middleware has been
 * configured (globally or locally to a component).
 */
WB.Routing.Router = function(
    $rootScope,
    $window,
    $log,
    $location,
    $route,
    _User,
    RouteHelper,
    RoutingHistory
) {
    $rootScope.$on('$routeChangeStart', function(e, nextRoute, currentRoute) {
        if (!currentRoute) {
            return;
        }

        const trackersExclusionSet = new Set($rootScope.App.config.TrackerExclusionList);

        if (   currentRoute && currentRoute.$$route.originalPath.startsWith('/weather-videos')
            && nextRoute    && nextRoute.$$route.originalPath.startsWith('/weather-videos')
            && bypassParameter in $location.search()
        )
        {
            $location.search(bypassParameter, false);
            e.preventDefault();
            return;
        }
        // User isn't on video page, so kill off the bypass parameter
        else if (bypassParameter in $location.search())
        {
            $location.search(bypassParameter, null);
        }

        // Save relevant route state
        nextRoute.locals = {};
        if (nextRoute.resolve) {
            nextRoute.locals.name = nextRoute.resolve.name();
            nextRoute.locals.controller = nextRoute.resolve.controller();
            if (nextRoute.resolve.popup) {
                nextRoute.locals.popup = nextRoute.resolve.popup();
            }
        }

        var previousStandardRoute = RoutingHistory.getPreviousStandardRoute();

        nextRoute.previousStandardRoute = previousStandardRoute;
        nextRoute.isSameLocation =
			nextRoute.params.location === currentRoute.params.location;
        nextRoute.isGoingToPopup = !!nextRoute.locals.popup;
        nextRoute.isComingFromPopup = !!RoutingHistory.get().locals.popup;
        nextRoute.isComingFromSameController =
			previousStandardRoute &&
			previousStandardRoute.locals.controller === nextRoute.locals.controller;

        if (!nextRoute.isComingFromSameController && !nextRoute.isGoingToPopup) {
            $rootScope.RouteLoader = 'Page';
        } else if (!nextRoute.isGoingToPopup) {
            $rootScope.RouteLoader = 'Module';
        } else if (nextRoute.isGoingToPopup && !nextRoute.isComingFromPopup) {
            $rootScope.RouteLoader = 'Popup';
        }

        if (!nextRoute.isComingFromPopup) {
            $rootScope.previousScrollPosition = $window.scrollY;
        }

        if ($rootScope?.App?.config?.TrackerExclusionList?.length) {
            if (trackersExclusionSet.has(currentRoute?.locals?.name) && !trackersExclusionSet.has(nextRoute?.locals?.name) && nextRoute?.$$route?.originalPath) {
                e.preventDefault();
                window.location.href = nextRoute.$$route.originalPath;
            }
        }

        if(nextRoute.isComingFromPopup 
            && !nextRoute.isGoingToPopup 
            && (nextRoute.$$route?.originalPath?.startsWith('/weather-forecast') 
                || nextRoute.$$route?.originalPath?.startsWith('/alerts'))
        ) {
            e.preventDefault();
            window.location.href = nextRoute.$$route.originalPath;
        }

        $rootScope.PendingRoute = nextRoute;
        currentRoute.throttle = true;
    });

    $rootScope.$on('$routeChangeSuccess', function(e, currentRoute, lastRoute) {
        if (bypassParameter in $location.search())
        {
            $location.search(bypassParameter, false);
        }
        $rootScope.RouteLoader = null;

        var finalizeRequest = function() {
            RoutingHistory.add(currentRoute);
            $rootScope.ActiveRoute = currentRoute;
            $rootScope.PendingRoute = null;
            $rootScope.$broadcast('$routeChangeFinished', currentRoute, lastRoute);
        };

        $log.debug(
            '[Router:' +
				currentRoute.locals.name +
				', ' +
				currentRoute.params.location +
				'] - Starting route.'
        );

        if (!lastRoute) {
            $log.debug(
                '[Router:' +
					currentRoute.locals.name +
					', ' +
					currentRoute.params.location +
					'] - Skipping route handling due to initial server request. It is not needed.'
            );
            finalizeRequest();
            return;
        }

        // Route to different location if metadata returns different location
        if (
            currentRoute?.locals?.metadata 
            && currentRoute?.locals?.metadata?.ActiveLocation?.Id 
			&& currentRoute?.locals?.metadata?.ActiveLocation?.Id !== _User?.ActiveLocation?.Id
        ) {
            $log.debug(
                '[Router:' +
					currentRoute?.locals?.name +
					', ' +
					currentRoute?.params?.location +
					'] - Different location returned in metadata. This is OK. Redirecting to [' +
					currentRoute?.locals?.metadata?.ActiveLocation?.Locality?.RouteString +
					'] from [' +
					_User?.ActiveLocation?.Locality?.RouteString +
					'].'
            );

            /**
             * TECHDEBT: 
             * we don't support location change in popups
             * there's likelihood for a cache hit if any of these pages had been visited
             * hence the returned metadata, if we ever get to this point, may have a wrong active location
             * hence will cause the app to revert to old location
             * NB: news page returns a stringified document as meta which explains why the initial logic  of  
             * currentRoute?.locals?.metadata 
             *  && currentRoute?.locals?.metadata?.ActiveLocation?.Id !== _User?.ActiveLocation?.Id
             * usually failed.
             */
            if (currentRoute?.locals?.popup) { 
                currentRoute.locals.metadata.ActiveLocation = { ..._User?.ActiveLocation };
            }

            currentRoute.throttle = true;

            RouteHelper.GoToLocation(currentRoute.locals.metadata.ActiveLocation);

            $location.replace();
            $route.reload();
            return;
        }

        // Replace route string if location param is different than active location

        if (
            currentRoute?.params?.location && currentRoute?.params?.location !== _User.ActiveLocation.Locality.RouteString
        ) {
            $log.debug(
                '[Router:' +
					currentRoute.locals.name +
					', ' +
					currentRoute.params.location +
					'] - Different location route string from the active location. We will update the URL to reflect the active location.'
            );
            RouteHelper.UpdateUrlForLocation();
            $location.replace();
        }

        finalizeRequest();
    });
};
WB.Routing.Router.$inject = [
    '$rootScope',
    '$window',
    '$log',
    '$location',
    '$route',
    '_User',
    'RouteHelper',
    'RoutingHistory'
];